
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1612',
  depVersions: {
  "customer-portal-app": "static-1.1612",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "data-fetching-client": "static-1.9438",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24615",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5352",
  "hs-test-utils": "static-1.7767",
  "hub-http": "static-1.5966",
  "hub-http-shared-msw-handlers": "static-1.9383",
  "hubspot-dlb": "static-2.1796",
  "hubspot-prosemirror": "static-1.17494",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11184",
  "I18n": "static-7.1558",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6235",
  "payment-link-components": "static-1.22828",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6676",
  "quartz-core": "static-1.5895",
  "react": "static-7.177",
  "react-colorpicker": "static-2.9973",
  "react-dlb": "static-1.71",
  "react-utils": "static-2.5139",
  "rich-text-lib": "static-1.19406",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17592",
  "ui-components-test-utils": "static-1.5322",
  "UIComponents": "static-3.8131",
  "foundations-assets": "static-1.4593",
  "foundations-components": "static-1.7444",
  "foundations-theming": "static-1.4170",
  "foundations-theming-specialty": "static-1.1886",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9391",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.492",
  "quartz-config": "static-1.454",
  "quartz-routing": "static-1.106",
  "quick-fetch": "static-1.3697",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16402",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7901",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4527",
  "ui-addon-react-router-dom": "static-1.9309",
  "usage-tracker": "static-1.7095",
  "usage-tracker-anonymous": "static-1.5512",
  "usage-tracker-core": "static-1.6945",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3192",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2953",
  "quartz-webpack": "static-1.2900",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "customer-data-objects": "static-1.7405",
  "frontend-preferences-client": "static-1.7688",
  "laboratory-lib": "static-3.6924",
  "onboarding-scopes": "static-1.6226",
  "rpc-client-utils": "static-1.4393",
  "ui-addon-opt": "static-4.8148",
  "HeadJS": "static-2.701",
  "hs-test-utils-bend-plugin": "static-1.2878",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3870",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7389",
  "cssUtils": "static-1.720",
  "customer-data-ui-utilities": "static-1.9586",
  "HubStyle": "static-2.11492",
  "knowledge-content-types": "static-1.8329",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.351",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.483",
  "ui-addon-emoji-picker": "static-1.9651",
  "ui-addon-i18n": "static-1.10892",
  "ui-business-units-lib": "static-1.8784",
  "ui-shepherd-react": "static-3.9906",
  "video-components-external": "static-1.10460",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4092",
  "commerce-tours-lib": "static-1.5662",
  "customer-data-properties": "static-1.50665",
  "getting-started-shared-tasks": "static-1.17771",
  "growth-onboarding-reliability": "static-1.4850",
  "onboarding-tours": "static-1.16205",
  "reference-resolvers-lite": "static-1.7851",
  "sales-checkout-service-client": "static-1.3438",
  "ui-addon-iframeable": "static-1.8802",
  "user-context": "static-1.4856",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "hubspotter-http": "static-1.4443",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-auth": "static-1.351",
  "quartz-head": "static-1.341",
  "quartz-test": "static-1.351",
  "usage-tracker-container": "static-1.7085",
  "ui-fonts": "static-1.446",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9189",
  "data-token-picker": "static-1.15980",
  "FileManagerLib": "static-1.38410",
  "property-translator": "static-1.5175",
  "atom": "static-1.4832",
  "merchandise-lib": "static-1.257",
  "purchase-motions-components": "static-1.5427",
  "salesImages": "static-1.520",
  "self-service-api": "static-1.9999",
  "SharedI18nStrings": "static-1.180",
  "upgrade-management-service-types": "static-1.4269",
  "foundations-components-test-utils": "static-1.4927",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1082",
  "bend-plugin-foundations-components": "static-1.3713",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.1086",
  "bend-plugin-foundations-theming": "static-1.2653",
  "foundations-theming-base": "static-1.3155",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4236",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2899",
  "inbound-db-properties-service-client": "static-1.3642",
  "superstore": "static-1.4533",
  "feedback-loader": "static-1.28778",
  "ai-components-ui-library": "static-1.8241",
  "ui-addon-video-player": "static-1.8456",
  "ui-coaching-tips": "static-1.27839",
  "sassPrefix": "static-1.151",
  "react-dnd-compat": "static-1.4385",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2247",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7921",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4410",
  "content-media-composition-data-lib": "static-1.11310",
  "content-media-compositions": "static-2.15317",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3916",
  "magpie-lib": "static-1.5355",
  "magpie-types": "static-1.4815",
  "media-bridge-lib": "static-1.18502",
  "video-data-lib": "static-1.34118",
  "commerce-products-lib": "static-1.8734",
  "crm-message-bus": "static-1.42234",
  "growth-data-modal": "static-1.5115",
  "hubspot-apollo-client": "static-1.4640",
  "onboarding-tours-client": "static-1.4419",
  "calling-global-api": "static-1.63527",
  "calling-internal-common": "static-1.31053",
  "calling-lifecycle-internal": "static-1.64909",
  "calling-lifecycle-messages": "static-1.57203",
  "conditional-properties-service-client": "static-1.3588",
  "crm-links": "static-1.6015",
  "customer-data-objects-ui-components": "static-1.12764",
  "customer-data-property-utils": "static-1.7833",
  "external-options-client-types": "static-1.3949",
  "file-manager-components": "static-1.22770",
  "framework-data-schema-resolvers": "static-1.6630",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.432",
  "inbound-db-meta-service-client": "static-1.3397",
  "inbounddb-objects-service-types": "static-1.4015",
  "meetings-icalendar-utils-lib": "static-1.395",
  "multi-currency-client-types": "static-1.3483",
  "object-builder-ui-client": "static-1.47841",
  "pipeline-validation-client-types": "static-1.3753",
  "property-value-citations": "static-1.1279",
  "pulse": "static-1.262",
  "smart-property-lib": "static-1.5739",
  "tiered-pricing": "static-1.772",
  "ui-addon-form-validation": "static-1.10756",
  "growth-onboarding-confetti": "static-1.2831",
  "growth-onboarding-next-action-utils": "static-1.1256",
  "navigation-components": "static-1.17141",
  "onboarding-tours-utils": "static-1.271",
  "ui-shepherd-tracker": "static-1.7287",
  "ui-universal-auth": "static-1.8638",
  "batch-promise": "static-1.1311",
  "navigation-messaging": "static-1.6468",
  "getting-started-shared-tasks-store": "static-1.16889",
  "hubspotter-http-shared-msw-handlers": "static-1.9381",
  "audio-components": "static-1.5554",
  "FileManagerCore": "static-1.38269",
  "FileManagerImages": "static-1.35921",
  "video-components": "static-1.12463",
  "growth-monetization-service-types": "static-1.4285",
  "nav-client-types": "static-1.2117",
  "purchase-motions-api": "static-1.5430",
  "signup-constants": "static-1.18309",
  "signup-ui-url-generator": "static-2.7823",
  "trials-service-types": "static-1.3686",
  "chatspot-core": "static-1.20156",
  "chirp-fetch": "static-1.1644",
  "ContentUtils": "static-1.67507",
  "copilot-toolkit": "static-1.10423",
  "growth-onboarding-feedback-components": "static-1.6346",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.487",
  "simple-logging-lib": "static-1.2813",
  "customer-data-tracking": "static-1.6643",
  "products-iframe-lib": "static-1.7211",
  "products-ui-components-shared-msw-handlers": "static-1.9765",
  "hubspot-apollo-cache": "static-1.99",
  "calling-error-reporting": "static-1.31059",
  "shared-worker-versioning": "static-1.10799",
  "calling-usage-tracker": "static-1.6300",
  "voice-sms-access-library": "static-1.121",
  "conversations-skeleton-state": "static-1.7011",
  "location-customization-utils-lib": "static-1.8435",
  "crm-pipelines-api-client-types": "static-1.3929",
  "framework-builder-read-service-client": "static-1.3812",
  "framework-data-schema-quick-fetch": "static-1.6535",
  "persist-promise": "static-1.3468",
  "directed-graph": "static-1.698",
  "event-emitter": "static-1.710",
  "breeze-intelligence-kit": "static-1.5261",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9466",
  "fsm": "static-1.3493",
  "policy-lib": "static-1.6546",
  "react-tinymce": "static-1.54516",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9529",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53642",
  "tinymce-plugins": "static-1.56756",
  "tinymce-themes": "static-1.55612",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4294",
  "video-embed": "static-1.34952",
  "content-icons-ui": "static-1.2140",
  "social-insights-client-types": "static-1.21246",
  "eligibility-engine-service-types": "static-1.2967",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4568",
  "integrations-lib": "static-1.15290",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4053",
  "calling-orchestration-schema": "static-1.34898",
  "crm-record-cards-service-types": "static-1.3416",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4283",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2806",
  "interframe": "static-3.4553",
  "tinymce-data": "static-1.39727",
  "ui-addon-sales-email": "static-1.4974",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11961",
  "layout-dnd-utils": "static-1.10936",
  "react-codemirror": "static-1.10389",
  "ui-brand-identity-lib": "static-1.13676",
  "NamespacedHubStyle": "static-2.8862",
  "outpost": "static-1.3969",
  "flux-actions": "static-1.302",
  "integrations-error-boundary-lib": "static-1.12705",
  "integrations-tracking-lib": "static-1.5345",
  "native-integrations-shared-strings": "static-1.7551",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10134",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67582",
  "layout-data-lib": "static-1.9261",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2760",
  "advanced-menus-core": "static-1.14758",
  "advanced-menus-lib": "static-1.11741",
  "ExportDialog": "static-6.10149",
  "ui-memberships-settings-lib": "static-1.33324",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14757",
  "simple-menus-lib": "static-1.16274"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1612",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "data-fetching-client": "/data-fetching-client/static-1.9438",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24615",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5352",
  "hs-test-utils": "/hs-test-utils/static-1.7767",
  "hub-http": "/hub-http/static-1.5966",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9383",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17494",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11184",
  "I18n": "/I18n/static-7.1558",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6235",
  "payment-link-components": "/payment-link-components/static-1.22828",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6676",
  "quartz-core": "/quartz-core/static-1.5895",
  "react": "/react/static-7.177",
  "react-colorpicker": "/react-colorpicker/static-2.9973",
  "react-dlb": "/react-dlb/static-1.71",
  "react-utils": "/react-utils/static-2.5139",
  "rich-text-lib": "/rich-text-lib/static-1.19406",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17592",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5322",
  "UIComponents": "/UIComponents/static-3.8131",
  "foundations-assets": "/foundations-assets/static-1.4593",
  "foundations-components": "/foundations-components/static-1.7444",
  "foundations-theming": "/foundations-theming/static-1.4170",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1886",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9391",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.492",
  "quartz-config": "/quartz-config/static-1.454",
  "quartz-routing": "/quartz-routing/static-1.106",
  "quick-fetch": "/quick-fetch/static-1.3697",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16402",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7901",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4527",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9309",
  "usage-tracker": "/usage-tracker/static-1.7095",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5512",
  "usage-tracker-core": "/usage-tracker-core/static-1.6945",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3192",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2953",
  "quartz-webpack": "/quartz-webpack/static-1.2900",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "customer-data-objects": "/customer-data-objects/static-1.7405",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7688",
  "laboratory-lib": "/laboratory-lib/static-3.6924",
  "onboarding-scopes": "/onboarding-scopes/static-1.6226",
  "rpc-client-utils": "/rpc-client-utils/static-1.4393",
  "ui-addon-opt": "/ui-addon-opt/static-4.8148",
  "HeadJS": "/HeadJS/static-2.701",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2878",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3870",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7389",
  "cssUtils": "/cssUtils/static-1.720",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9586",
  "HubStyle": "/HubStyle/static-2.11492",
  "knowledge-content-types": "/knowledge-content-types/static-1.8329",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.351",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9651",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10892",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8784",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9906",
  "video-components-external": "/video-components-external/static-1.10460",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4092",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5662",
  "customer-data-properties": "/customer-data-properties/static-1.50665",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17771",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4850",
  "onboarding-tours": "/onboarding-tours/static-1.16205",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7851",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3438",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8802",
  "user-context": "/user-context/static-1.4856",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "hubspotter-http": "/hubspotter-http/static-1.4443",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-auth": "/quartz-auth/static-1.351",
  "quartz-head": "/quartz-head/static-1.341",
  "quartz-test": "/quartz-test/static-1.351",
  "usage-tracker-container": "/usage-tracker-container/static-1.7085",
  "ui-fonts": "/ui-fonts/static-1.446",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9189",
  "data-token-picker": "/data-token-picker/static-1.15980",
  "FileManagerLib": "/FileManagerLib/static-1.38410",
  "property-translator": "/property-translator/static-1.5175",
  "atom": "/atom/static-1.4832",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "purchase-motions-components": "/purchase-motions-components/static-1.5427",
  "salesImages": "/salesImages/static-1.520",
  "self-service-api": "/self-service-api/static-1.9999",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4269",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4927",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1082",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3713",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.1086",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2653",
  "foundations-theming-base": "/foundations-theming-base/static-1.3155",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4236",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3642",
  "superstore": "/superstore/static-1.4533",
  "feedback-loader": "/feedback-loader/static-1.28778",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8241",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8456",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27839",
  "sassPrefix": "/sassPrefix/static-1.151",
  "react-dnd-compat": "/react-dnd-compat/static-1.4385",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2247",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7921",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4410",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11310",
  "content-media-compositions": "/content-media-compositions/static-2.15317",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3916",
  "magpie-lib": "/magpie-lib/static-1.5355",
  "magpie-types": "/magpie-types/static-1.4815",
  "media-bridge-lib": "/media-bridge-lib/static-1.18502",
  "video-data-lib": "/video-data-lib/static-1.34118",
  "commerce-products-lib": "/commerce-products-lib/static-1.8734",
  "crm-message-bus": "/crm-message-bus/static-1.42234",
  "growth-data-modal": "/growth-data-modal/static-1.5115",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4640",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4419",
  "calling-global-api": "/calling-global-api/static-1.63527",
  "calling-internal-common": "/calling-internal-common/static-1.31053",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3588",
  "crm-links": "/crm-links/static-1.6015",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12764",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7833",
  "external-options-client-types": "/external-options-client-types/static-1.3949",
  "file-manager-components": "/file-manager-components/static-1.22770",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6630",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.432",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4015",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.395",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3483",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47841",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3753",
  "property-value-citations": "/property-value-citations/static-1.1279",
  "pulse": "/pulse/static-1.262",
  "smart-property-lib": "/smart-property-lib/static-1.5739",
  "tiered-pricing": "/tiered-pricing/static-1.772",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10756",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2831",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1256",
  "navigation-components": "/navigation-components/static-1.17141",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.271",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7287",
  "ui-universal-auth": "/ui-universal-auth/static-1.8638",
  "batch-promise": "/batch-promise/static-1.1311",
  "navigation-messaging": "/navigation-messaging/static-1.6468",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16889",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9381",
  "audio-components": "/audio-components/static-1.5554",
  "FileManagerCore": "/FileManagerCore/static-1.38269",
  "FileManagerImages": "/FileManagerImages/static-1.35921",
  "video-components": "/video-components/static-1.12463",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4285",
  "nav-client-types": "/nav-client-types/static-1.2117",
  "purchase-motions-api": "/purchase-motions-api/static-1.5430",
  "signup-constants": "/signup-constants/static-1.18309",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7823",
  "trials-service-types": "/trials-service-types/static-1.3686",
  "chatspot-core": "/chatspot-core/static-1.20156",
  "chirp-fetch": "/chirp-fetch/static-1.1644",
  "ContentUtils": "/ContentUtils/static-1.67507",
  "copilot-toolkit": "/copilot-toolkit/static-1.10423",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6346",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.487",
  "simple-logging-lib": "/simple-logging-lib/static-1.2813",
  "customer-data-tracking": "/customer-data-tracking/static-1.6643",
  "products-iframe-lib": "/products-iframe-lib/static-1.7211",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9765",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.99",
  "calling-error-reporting": "/calling-error-reporting/static-1.31059",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10799",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6300",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.121",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7011",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8435",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3929",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3812",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6535",
  "persist-promise": "/persist-promise/static-1.3468",
  "directed-graph": "/directed-graph/static-1.698",
  "event-emitter": "/event-emitter/static-1.710",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5261",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9466",
  "fsm": "/fsm/static-1.3493",
  "policy-lib": "/policy-lib/static-1.6546",
  "react-tinymce": "/react-tinymce/static-1.54516",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9529",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53642",
  "tinymce-plugins": "/tinymce-plugins/static-1.56756",
  "tinymce-themes": "/tinymce-themes/static-1.55612",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4294",
  "video-embed": "/video-embed/static-1.34952",
  "content-icons-ui": "/content-icons-ui/static-1.2140",
  "social-insights-client-types": "/social-insights-client-types/static-1.21246",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2967",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4568",
  "integrations-lib": "/integrations-lib/static-1.15290",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4053",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34898",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3416",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4283",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2806",
  "interframe": "/interframe/static-3.4553",
  "tinymce-data": "/tinymce-data/static-1.39727",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4974",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11961",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10936",
  "react-codemirror": "/react-codemirror/static-1.10389",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13676",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8862",
  "outpost": "/outpost/static-1.3969",
  "flux-actions": "/flux-actions/static-1.302",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12705",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5345",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7551",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10134",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67582",
  "layout-data-lib": "/layout-data-lib/static-1.9261",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2760",
  "advanced-menus-core": "/advanced-menus-core/static-1.14758",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11741",
  "ExportDialog": "/ExportDialog/static-6.10149",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33324",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14757",
  "simple-menus-lib": "/simple-menus-lib/static-1.16274"
}
};
